/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Paket_S2Inputs */

const en_tut_paket_s2 = /** @type {(inputs: Tut_Paket_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the number of paid **Anggota**, enter a voucher code if you have one, then press **Pilih paket** on the card you want.`)
};

const id_tut_paket_s2 = /** @type {(inputs: Tut_Paket_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atur **Jumlah anggota** berbayar, masukkan **Kode voucher** kalau ada, lalu tekan **Pilih paket** pada kartu yang Anda inginkan.`)
};

/**
* | output |
* | --- |
* | "Set the number of paid **Anggota**, enter a voucher code if you have one, then press **Pilih paket** on the card you want." |
*
* @param {Tut_Paket_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_paket_s2 = /** @type {((inputs?: Tut_Paket_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Paket_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_paket_s2(inputs)
	return en_tut_paket_s2(inputs)
});